import { FlyoutMenuAction, FlyoutMenuOption } from "@app/shared/components/flyout-menu/flyout-menu.component";
import { DbHelper } from "@app/shared/model/db-object.model";
import { ClassImporterExporter, ImportMap } from "@app/shared/resources/class-importer-exporter.service";

export enum CommandProviders {
    PUSH = "Apns",
    SCENE = "SceneCommand",
    EMAIL = "EmailCommand",
    SERVICE_OPERATION = "ServiceOperationCommand",
    SERVICE_PROPERTY = "ServicePropertyCommand",
    SERVICE_COMMAND = "ServiceCommand",
    DCO_OPERATION = "DCOOperationCommand",
    DCO_PROPERTY = "DCOPropertyCommand",
    GROUP = "GroupCommand",
    FILTER_RULE_STATE = "FilterRuleStateCommand",
    RULE_STATE = "RuleStateCommand",
    LOG = "LogCommand",
    EVENT = "EventCommand",
    WAIT_TIME = "WaitTime",
}

export interface EventHandlers {
    edit?: FlyoutMenuAction;
    remove?: FlyoutMenuAction;
}

export interface Command {
    name: string;
    commandId: string;
    commandType: string;
    delay?: number;
}

export interface CommandData {
    name: string;
    command_id: string;
    command_type: string;
}

export abstract class CommandHelper extends DbHelper<any, any> {
    static fromCHObject(command): Command {
        return ClassImporterExporter.importObject(command, this.defaultImportMap);
    }

    static registerEventHandlers(handlers: EventHandlers): FlyoutMenuOption[] {
        const flyoutMenuActions: FlyoutMenuOption[] = [];

        if (handlers.edit) {
            flyoutMenuActions.push({ name: $localize`:@@SHARED.BTN.EDIT:Edit`, action: handlers.edit });
        }

        if (handlers.remove) {
            flyoutMenuActions.push({ name: $localize`:@@SHARED.BTN.REMOVE:Remove`, action: handlers.remove });
        }

        return flyoutMenuActions;
    }

    static isValid(command: Command): boolean {
        return !!command;
    }

    static readonly importMap: ImportMap<any, any>;
    static defaultImportMap: ImportMap<Command, CommandData> = [
        { i: "name", o: "name" },
        { i: "command_id", o: "commandId" },
        { i: "command_type", o: "commandType" },
    ];

    static getDefault(param?: any): Command {
        return {
            name: null,
            commandId: null,
            commandType: null,
            delay: 0,
        };
    }

    static exportObject(rule, command, importMap) {
        return ClassImporterExporter.exportObject(command, importMap, false);
    }
}
